import { apiService } from 'adapters/apiService';
import { METHOD, PATHS } from 'adapters/constants';
import { HeaderData } from 'adapters/types';
import { PDFGenerationBase64Type } from 'hooks/types';

export const fetchPDFGenerationBase64 = async (
  headers: HeaderData,
  documentId: string,
  storeId: string
): Promise<PDFGenerationBase64Type> => {
  const response = await apiService({
    url: `${PATHS.getAccountingVirtualCardPdfGeneration()}/${documentId}`,
    method: METHOD.GET,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (!response?.ok) throw new Error(response.statusText);
  return response.json() as Promise<PDFGenerationBase64Type>;
};
